import {FILTER_ALL, FILTER_CUSTOM, FILTER_NONE} from './filters';

export default [
  {key: FILTER_ALL, label: 'Alle nicht-unterbr. Stör.'},
  {key: FILTER_CUSTOM, label: 'gefiltert (Nicht-unterbr. Stör.)'},
  {key: FILTER_NONE, label: 'Keine nicht-unterbr. Stör.'},
];
